import { Quiz } from '@renderer/@types/types'

export const quiz1: Quiz = [
  // {
  //   id: '1',
  //   type: 'multiple',
  //   goodOptionsIds: [1, 2],
  //   options: [
  //     {
  //       id: 1,
  //       value: 'Paris'
  //     },
  //     {
  //       id: 2,
  //       value: 'Lyon'
  //     },
  //     {
  //       id: 3,
  //       value: 'Marseille'
  //     },
  //     {
  //       id: 4,
  //       value: 'Toulouse'
  //     }
  //   ]
  // },
  // {
  //   id: '2',
  //   type: 'single',
  //   goodOptionId: 1,
  //   options: [
  //     {
  //       id: 1,
  //       value: 'Paris'
  //     }
  //   ]
  // }
]

export const quizGroup: Quiz = [
  {
    id: 'quizGroup1',
    type: 'single',
    image: 'quizGroup-1.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Oui'
      },
      {
        id: 2,
        value: 'Non'
      }
    ]
  },
  {
    id: 'quizGroup2',
    type: 'single',
    image: 'quizGroup-2.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '10'
      },
      {
        id: 2,
        value: '16'
      },
      {
        id: 3,
        value: '20'
      },
      {
        id: 4,
        value: '25'
      }
    ]
  },
  {
    id: 'quizGroup3',
    type: 'single',
    image: 'quizGroup-3.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1 500 km'
      },
      {
        id: 2,
        value: '15 000 km'
      },
      {
        id: 3,
        value: 'plus de 150 000 km'
      }
    ]
  },
  {
    id: 'quizGroup4',
    type: 'single',
    image: 'quizGroup-4.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '5'
      },
      {
        id: 2,
        value: '7'
      },
      {
        id: 3,
        value: '9'
      },
      {
        id: 4,
        value: '11'
      }
    ]
  },
  {
    id: 'quizGroup5',
    type: 'single',
    image: 'quizGroup-5.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Moins de 50 000'
      },
      {
        id: 2,
        value: 'Entre 50 000 et 70 000'
      },
      {
        id: 3,
        value: 'Entre 70 000 et 80 000'
      },
      {
        id: 4,
        value: 'Plus de 80 000'
      }
    ]
  },
  {
    id: 'quizGroup6',
    type: 'single',
    image: 'quizGroup-6.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Métro'
      },
      {
        id: 2,
        value: 'Tramway'
      },
      {
        id: 3,
        value: 'Avion'
      },
      {
        id: 4,
        value: 'Bus urbain'
      }
    ]
  },
  {
    id: 'quizGroup7',
    type: 'single',
    image: 'quizGroup-7.webp',
    goodOptionId: 4,
    options: [
      {
        id: 1,
        value: '30 métiers'
      },
      {
        id: 2,
        value: '50 métiers'
      },
      {
        id: 3,
        value: '100 métiers'
      },
      {
        id: 4,
        value: 'Plus de 200 métiers'
      }
    ]
  },
  {
    id: 'quizGroup8',
    type: 'single',
    image: 'quizGroup-8.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Oui'
      },
      {
        id: 2,
        value: 'Non'
      }
    ]
  },
  {
    id: 'quizGroup9',
    type: 'multiple',
    image: 'quizGroup-9.webp',
    goodOptionsIds: [1, 2, 3, 4, 5],
    options: [
      {
        id: 1,
        value: 'Immobilier'
      },
      {
        id: 2,
        value: 'Télécoms'
      },
      {
        id: 3,
        value: 'Energie'
      },
      {
        id: 4,
        value: 'Logistique urbaine'
      },
      {
        id: 5,
        value: 'Nouvelles mobilités'
      }
    ]
  },
  {
    id: 'quizGroup10',
    type: 'single',
    image: 'quizGroup-10.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1970'
      },
      {
        id: 2,
        value: '1995'
      },
      {
        id: 3,
        value: '2002'
      },
      {
        id: 4,
        value: '2017'
      }
    ]
  },
  {
    id: 'quizGroup11',
    type: 'multiple',
    image: 'quizGroup-11.webp',
    goodOptionsIds: [1, 2, 3],
    options: [
      {
        id: 1,
        value: 'Les Autorités Organisatrices de la Mobilité'
      },
      {
        id: 2,
        value: 'Les Industriels'
      },
      {
        id: 3,
        value: 'Les Opérateurs'
      }
    ]
  },
  {
    id: 'quizGroup12',
    type: 'multiple',
    image: 'quizGroup-12.webp',
    goodOptionsIds: [1, 3],
    options: [
      {
        id: 1,
        value: 'Faciliter l’insertion professionnelle'
      },
      {
        id: 2,
        value: 'Eduquer à la citoyenneté'
      },
      {
        id: 3,
        value: 'Favoriser l’égalité d’accès aux ressources et aux opportunités de la ville'
      },
      {
        id: 4,
        value: 'Donner accès à la culture'
      }
    ]
  }
]

export const quizTransport: Quiz = [
  {
    id: 'quizTransport1',
    type: 'single',
    image: 'quizTransport-1.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1961'
      },
      {
        id: 2,
        value: '1962'
      },
      {
        id: 3,
        value: '1964'
      },
      {
        id: 4,
        value: '1960'
      }
    ]
  },
  {
    id: 'quizTransport2',
    type: 'single',
    image: 'quizTransport-2.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Châtelet'
      },
      {
        id: 2,
        value: 'Montparnasse'
      },
      {
        id: 3,
        value: 'Auber'
      },
      {
        id: 4,
        value: 'Saint-Germain en Laye'
      }
    ]
  },
  {
    id: 'quizTransport3',
    type: 'single',
    image: 'quizTransport-3.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1957'
      },
      {
        id: 2,
        value: '1968'
      },
      {
        id: 3,
        value: '1975'
      },
      {
        id: 4,
        value: '1981'
      }
    ]
  },
  {
    id: 'quizTransport4',
    type: 'single',
    image: 'quizTransport-4.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1979'
      },
      {
        id: 2,
        value: '1985'
      },
      {
        id: 3,
        value: '1992'
      },
      {
        id: 4,
        value: '1996'
      }
    ]
  },
  {
    id: 'quizTransport5',
    type: 'single',
    image: 'quizTransport-5.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1982'
      },
      {
        id: 2,
        value: '1987'
      },
      {
        id: 3,
        value: '1992'
      },
      {
        id: 4,
        value: '1998'
      }
    ]
  },
  {
    id: 'quizTransport6',
    type: 'single',
    image: 'quizTransport-6.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1995'
      },
      {
        id: 2,
        value: '1998'
      },
      {
        id: 3,
        value: '2000'
      },
      {
        id: 4,
        value: '2024'
      }
    ]
  },
  {
    id: 'quizTransport7',
    type: 'single',
    image: 'quizTransport-7.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '2000'
      },
      {
        id: 2,
        value: '2007'
      },
      {
        id: 3,
        value: '2011'
      },
      {
        id: 4,
        value: '2016'
      }
    ]
  },
  {
    id: 'quizTransport8',
    type: 'single',
    image: 'quizTransport-8.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1905'
      },
      {
        id: 2,
        value: '1939'
      },
      {
        id: 3,
        value: '1949'
      },
      {
        id: 4,
        value: '1960'
      }
    ]
  },
  {
    id: 'quizTransport9',
    type: 'single',
    image: 'quizTransport-9.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1895'
      },
      {
        id: 2,
        value: '1900'
      },
      {
        id: 3,
        value: '1905'
      },
      {
        id: 4,
        value: '1910'
      }
    ]
  },
  {
    id: 'quizTransport10',
    type: 'single',
    image: 'quizTransport-10.webp',
    goodOptionId: 4,
    options: [
      {
        id: 1,
        value: '1991'
      },
      {
        id: 2,
        value: '1975'
      },
      {
        id: 3,
        value: '2000'
      },
      {
        id: 4,
        value: '1985'
      }
    ]
  }
]

export const quizSolutionVille: Quiz = [
  {
    id: 'quizSolutionVille1',
    type: 'single',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value:
          'Répondre aux appels d’offre dans le cadre de l’ouverture à la concurrence des transports publics portée par Île-de-France Mobilités et opérer les réseaux de transport qu’elle remporte'
      },
      {
        id: 2,
        value:
          'Proposer des services urbains aux villes, collectivités et entreprises sur-mesure pour relever le défi de la transition écologique des villes'
      },
      {
        id: 3,
        value:
          'Opérer des réseaux de transport urbain et interurbain en dehors du réseau « historique » de la RATP en région parisienne'
      },
      {
        id: 4,
        value:
          'Agir en faveur de l’insertion sociale, en initiant et en soutenant des initiatives d’intérêt général'
      }
    ]
  },
  {
    id: 'quizSolutionVille2',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'La santé'
      },
      {
        id: 2,
        value: 'Le sport'
      },
      {
        id: 3,
        value: 'L’énergie'
      },
      {
        id: 4,
        value: 'L’éducation'
      }
    ]
  },
  {
    id: 'quizSolutionVille3',
    type: 'single',
    goodOptionId: 4,
    options: [
      {
        id: 1,
        value: 'RATP Cap Ile-de-France et RATP Dev'
      },
      {
        id: 2,
        value: 'RATP Maintenance Service et RATP Sécurité Expertises'
      },
      {
        id: 3,
        value: 'RATP Capital Innovation et RATP Connect'
      },
      {
        id: 4,
        value: 'RATP Habitat et RATP Real Estate'
      }
    ]
  },
  {
    id: 'quizSolutionVille4',
    type: 'single',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: '170 000 km'
      },
      {
        id: 2,
        value: '27 000 km'
      },
      {
        id: 3,
        value: '1200 km'
      },
      {
        id: 4,
        value: '640 km'
      }
    ]
  },
  {
    id: 'quizSolutionVille5',
    type: 'single',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Investir uniquement dans des entreprises liées au secteur du transport public'
      },
      {
        id: 2,
        value:
          "Investir dans des projets œuvrant dans les secteurs de la mobilité durable, de l'immobilier urbain et de la logistique du dernier kilomètre"
      },
      {
        id: 3,
        value: 'Financer des projets exclusivement dans le domaine de la technologie informatique'
      },
      {
        id: 4,
        value:
          'Investir dans les industries pétrolières et gazières pour soutenir la transition énergétique'
      }
    ]
  },
  {
    id: 'quizSolutionVille6',
    type: 'single',
    goodOptionId: 4,
    options: [
      {
        id: 1,
        value: 'Offrir des logements exclusivement aux étudiants étrangers'
      },
      {
        id: 2,
        value: 'Construire des bureaux pour les collectivités locales'
      },
      {
        id: 3,
        value: 'Vendre des logements privés'
      },
      {
        id: 4,
        value: 'Loger les travailleurs essentiels franciliens en cœur de ville'
      }
    ]
  },
  {
    id: 'quizSolutionVille7',
    type: 'single',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'En les transformant en parkings pour particuliers'
      },
      {
        id: 2,
        value: 'En accueillant des activités de livraison du dernier kilomètre'
      },
      {
        id: 3,
        value: 'En y installant des espaces de coworking pour les startups'
      },
      {
        id: 4,
        value: 'En y organisant des événements culturels'
      }
    ]
  },
  {
    id: 'quizSolutionVille8',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '20 % de réduction des émissions de GES et 10 % de NOx'
      },
      {
        id: 2,
        value: '60 % de réduction des particules fines et 30 % de GES'
      },
      {
        id: 3,
        value: '80 % de réduction des émissions de GES, 49 % de particules fines et 80 % de NOx'
      },
      {
        id: 4,
        value: '10 % de réduction de toutes les émissions polluantes'
      }
    ]
  }
]

export const quizInnovation: Quiz = [
  {
    id: 'quizInnovation1',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1'
      },
      {
        id: 2,
        value: '7'
      },
      {
        id: 3,
        value: '16'
      }
    ]
  },
  {
    id: 'quizInnovation2',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '3'
      },
      {
        id: 2,
        value: '5'
      },
      {
        id: 3,
        value: '9'
      }
    ]
  },
  {
    id: 'quizInnovation3',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '50'
      },
      {
        id: 2,
        value: '150'
      },
      {
        id: 3,
        value: '300'
      }
    ]
  },
  {
    id: 'quizInnovation4',
    type: 'single',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '60'
      },
      {
        id: 2,
        value: '270'
      },
      {
        id: 3,
        value: '1200'
      }
    ]
  },
  {
    id: 'quizInnovation5',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Les gilets pare-chocs'
      },
      {
        id: 2,
        value: 'Les équipements bioniques'
      },
      {
        id: 3,
        value: 'Les exosquelettes'
      }
    ]
  },
  {
    id: 'quizInnovation6',
    type: 'single',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Ligne 393 | Thiais – Carrefour de la Résistance ↔ Sucy-Bonneuil RER'
      },
      {
        id: 2,
        value: 'Ligne 39 | Issy-les-Moulineaux – Frères voisins ↔ Gare du Nord'
      },
      {
        id: 3,
        value: 'Ligne 4602 | Centre Commercial Ulis 2 ↔ Gare de Massy-Palaiseau'
      }
    ]
  },
  {
    id: 'quizInnovation7',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Réduire de 25 % le nombre de bus en circulation'
      },
      {
        id: 2,
        value: 'Remplacer uniquement les bus diesel les plus anciens'
      },
      {
        id: 3,
        value: 'Convertir 100 % de la flotte de bus à l’électrique ou au biométhane d’ici 2025'
      }
    ]
  },
  {
    id: 'quizInnovation8',
    type: 'single',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Les eaux d’exhaure'
      },
      {
        id: 2,
        value: 'Les eaux pluviales'
      },
      {
        id: 3,
        value: 'Les eaux grises'
      }
    ]
  },
  {
    id: 'quizInnovation9',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '32%'
      },
      {
        id: 2,
        value: '54%'
      },
      {
        id: 3,
        value: '99%'
      }
    ]
  },
  {
    id: 'quizInnovation10',
    type: 'single',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Pour réduire le coût d’entretien des freins'
      },
      {
        id: 2,
        value: 'Pour améliorer la qualité de l’air dans les espaces souterrains'
      },
      {
        id: 3,
        value: 'Pour rendre le freinage totalement silencieux'
      }
    ]
  },
  {
    id: 'quizInnovation11',
    type: 'single',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Brest'
      },
      {
        id: 2,
        value: 'Lyon'
      },
      {
        id: 3,
        value: 'Strasbourg'
      },
      {
        id: 4,
        value: 'Toulon'
      }
    ]
  }
]

export const quizRatpDevLegacy: Quiz = [
  {
    id: 'quizRatpDev1',
    type: 'single',
    image: 'quizRatpDev-1.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Fabriquer des trains'
      },
      {
        id: 2,
        value: 'Développer des jeux vidéo'
      },
      {
        id: 3,
        value: 'Exploiter et maintenir des réseaux de transport publics à l’international'
      },
      {
        id: 4,
        value: 'Gérer les infrastructures ferroviaires françaises'
      }
    ]
  },
  {
    id: 'quizRatpDev2',
    type: 'single',
    image: 'quizRatpDev-2.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Moins de 7'
      },
      {
        id: 2,
        value: 'Environ 17'
      },
      {
        id: 3,
        value: 'Plus de 27'
      },
      {
        id: 4,
        value: 'Plus de 37'
      }
    ]
  },
  {
    id: 'quizRatpDev3',
    type: 'single',
    image: 'quizRatpDev-3.webp',
    goodOptionId: 4,
    options: [
      {
        id: 1,
        value: '2 000'
      },
      {
        id: 2,
        value: '5 000'
      },
      {
        id: 3,
        value: '10 000'
      },
      {
        id: 4,
        value: '25 000'
      }
    ]
  },
  {
    id: 'quizRatpDev4',
    type: 'multiple',
    image: 'quizRatpDev-4.webp',
    goodOptionsIds: [1, 2, 3],
    options: [
      {
        id: 1,
        value: 'Métro'
      },
      {
        id: 2,
        value: 'Tramway'
      },
      {
        id: 3,
        value: 'Navette fluviale'
      },
      {
        id: 4,
        value: 'Avion'
      }
    ]
  },
  {
    id: 'quizRatpDev5',
    type: 'single',
    image: 'quizRatpDev-5.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Toulouse'
      },
      {
        id: 2,
        value: 'Lyon'
      },
      {
        id: 3,
        value: 'Toulon'
      },
      {
        id: 4,
        value: 'Nice'
      }
    ]
  },
  {
    id: 'quizRatpDev6',
    type: 'multiple',
    image: 'quizRatpDev-6.webp',
    goodOptionsIds: [2, 3],
    options: [
      {
        id: 1,
        value: 'Le métro de Dubaï'
      },
      {
        id: 2,
        value: 'Le métro de Riyad'
      },
      {
        id: 3,
        value: 'Le métro de Doha'
      },
      {
        id: 4,
        value: 'le métro de Abou Dabi'
      }
    ]
  },
  // {
  //   id: 'quizRatpDev7',
  //   type: 'single',
  //   image: 'quizRatpDev-7.webp',
  //   goodOptionId: 3,
  //   options: [
  //     {
  //       id: 1,
  //       value: '5 ans'
  //     },
  //     {
  //       id: 2,
  //       value: '10 ans'
  //     },
  //     {
  //       id: 3,
  //       value: '15 ans'
  //     },
  //     {
  //       id: 4,
  //       value: '20 ans'
  //     }
  //   ]
  // },
  {
    id: 'quizRatpDev7',
    type: 'single',
    image: 'quizRatpDev-7.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Il propose la location de skateboard en libre-service '
      },
      {
        id: 2,
        value: 'Il dispose de navettes autonomes'
      },
      {
        id: 3,
        value: 'Il intègre un centre de formation dédié à la maintenance des bus à hydrogène'
      },
      {
        id: 4,
        value: 'Il offre un mode de transport fluvial et respectueux de l’environnement'
      }
    ]
  },
  {
    id: 'quizRatpDev8',
    type: 'single',
    image: 'quizRatpDev-8.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: "Il s'agit d'une ligne souterraine reliant l’aéroport"
      },
      {
        id: 2,
        value: 'C’est la première ligne de tramway de la ville'
      },
      {
        id: 3,
        value: 'Elle est entièrement automatisée et aérienne'
      },
      {
        id: 4,
        value: 'Elle est réservée au fret'
      }
    ]
  },
  {
    id: 'quizRatpDev9',
    type: 'multiple',
    image: 'quizRatpDev-9.webp',
    goodOptionsIds: [1, 3],
    options: [
      {
        id: 1,
        value: 'Métro automatique'
      },
      {
        id: 2,
        value: 'Tramway'
      },
      {
        id: 3,
        value: 'Bus à Haut niveau de Service'
      },
      {
        id: 4,
        value: 'Ferroviaire'
      }
    ]
  },
  // {
  //   id: 'quizRatpDev10',
  //   type: 'single',
  //   image: 'quizRatpDev-10.webp',
  //   goodOptionId: 3,
  //   options: [
  //     {
  //       id: 1,
  //       value: '35 %'
  //     },
  //     {
  //       id: 2,
  //       value: '40 %'
  //     },
  //     {
  //       id: 3,
  //       value: '50 %'
  //     },
  //     {
  //       id: 4,
  //       value: '60 %'
  //     }
  //   ]
  // },
  {
    id: 'quizRatpDev10',
    type: 'single',
    image: 'quizRatpDev-10.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Egypte'
      },
      {
        id: 2,
        value: 'Maroc'
      },
      {
        id: 3,
        value: 'Italie'
      },
      {
        id: 4,
        value: 'Hong Kong'
      }
    ]
  }
]

export const quizRatpDevMobco: Quiz = [
  {
    id: 'quizRatpDevMobco1',
    type: 'single',
    image: 'quizRatpDevMobco-1.webp',
    goodOptionId: 1,
    options: [
      { id: 1, value: 'Le choix naturel' },
      { id: 2, value: 'La mobilité pour tous' },
      { id: 3, value: 'Le choix durable' },
      { id: 4, value: 'Le meilleur de la mobilité' }
    ]
  },
  {
    id: 'quizRatpDevMobco2',
    type: 'single',
    image: 'quizRatpDevMobco-2.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: '9' },
      { id: 2, value: '16' },
      { id: 3, value: '12' },
      { id: 4, value: '18' }
    ]
  },
  {
    id: 'quizRatpDevMobco3',
    type: 'single',
    image: 'quizRatpDevMobco-3.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'Plus de 2 millions' },
      { id: 2, value: 'Plus de 3 millions' },
      { id: 3, value: 'Plus de 4 millions' },
      { id: 4, value: 'Plus de 5 millions' }
    ]
  },
  {
    id: 'quizRatpDevMobco4',
    type: 'single',
    image: 'quizRatpDevMobco-4.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'Métro' },
      { id: 2, value: 'Tramway' },
      { id: 3, value: 'Avion' },
      { id: 4, value: 'Navette maritime' }
    ]
  },
  {
    id: 'quizRatpDevMobco5',
    type: 'single',
    image: 'quizRatpDevMobco-5.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: 'Bretagne' },
      { id: 2, value: 'Normandie' },
      { id: 3, value: 'Occitanie' },
      { id: 4, value: 'Corse' }
    ]
  },
  {
    id: 'quizRatpDevMobco6',
    type: 'multiple',
    image: 'quizRatpDevMobco-6.webp',
    goodOptionsIds: [1, 2],
    options: [
      { id: 1, value: 'Tramway' },
      { id: 2, value: 'Bus' },
      { id: 3, value: 'Navette fluviale' },
      { id: 4, value: 'Vélo' }
    ]
  },
  {
    id: 'quizRatpDevMobco7',
    type: 'single',
    image: 'quizRatpDevMobco-7.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'Une ligne ferroviaire' },
      { id: 2, value: 'Un réseau de BHNS' },
      { id: 3, value: 'Une ligne de métro automatique' },
      { id: 4, value: 'Un réseau de navettes TAD' }
    ]
  },
  {
    id: 'quizRatpDevMobco8',
    type: 'single',
    image: 'quizRatpDevMobco-8.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'Plus de 30' },
      { id: 2, value: 'Plus de 40' },
      { id: 3, value: 'Plus de 50' },
      { id: 4, value: 'Plus de 60' }
    ]
  },
  {
    id: 'quizRatpDevMobco9',
    type: 'multiple',
    image: 'quizRatpDevMobco-9.webp',
    goodOptionsIds: [1, 2, 3, 4],
    options: [
      { id: 1, value: 'Engagement social' },
      { id: 2, value: 'Engagement environnemental' },
      { id: 3, value: 'Engagement sociétal' },
      { id: 4, value: 'Engagement collectif' }
    ]
  },
  {
    id: 'quizRatpDevMobco10',
    type: 'single',
    image: 'quizRatpDevMobco-10.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Construire une gouvernance solide et adopter des modèles contractuels collaboratifs'
      },
      {
        id: 2,
        value: 'Faire de l\'automatisation une transformation technocentrée tout en gérant la complexité technique'
      },
      { id: 3, value: 'Offrir une expérience voyageurs en constante amélioration' },
      {
        id: 4,
        value: 'Positionner le métro automatique comme la colonne vertébrale, durable et résiliente, de la transformation urbaine'
      }
    ]
  }
]

export const quizRatpDev = quizRatpDevMobco

export const quizMetroMusic: Quiz = [
  {
    id: 'quizMetroMusic1',
    type: 'single',
    image: 'quizMetroMusic-1.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '2017'
      },
      {
        id: 2,
        value: '1997'
      },
      {
        id: 3,
        value: '2003'
      }
    ]
  },
  {
    id: 'quizMetroMusic2',
    type: 'single',
    image: 'quizMetroMusic-2.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Clara LUCCIANI'
      },
      {
        id: 2,
        value: 'Santa'
      },
      {
        id: 3,
        value: 'Zaz'
      }
    ]
  },
  {
    id: 'quizMetroMusic3',
    type: 'single',
    image: 'quizMetroMusic-3.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: '20 ans'
      },
      {
        id: 2,
        value: '15 ans'
      },
      {
        id: 3,
        value: '30 ans'
      }
    ]
  },
  {
    id: 'quizMetroMusic4',
    type: 'single',
    image: 'quizMetroMusic-4.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'L’Olympia'
      },
      {
        id: 2,
        value: 'La Cigale'
      },
      {
        id: 3,
        value: 'Zénith de Paris'
      }
    ]
  },
  {
    id: 'quizMetroMusic5',
    type: 'single',
    image: 'quizMetroMusic-5.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '200'
      },
      {
        id: 2,
        value: '300'
      },
      {
        id: 3,
        value: '400'
      }
    ]
  },
  {
    id: 'quizMetroMusic6',
    type: 'single',
    image: 'quizMetroMusic-6.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1'
      },
      {
        id: 2,
        value: '2'
      },
      {
        id: 3,
        value: '3'
      }
    ]
  },
  {
    id: 'quizMetroMusic7',
    type: 'single',
    image: 'quizMetroMusic-7.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Musique du monde'
      },
      {
        id: 2,
        value: 'Folk'
      },
      {
        id: 3,
        value: 'Pop'
      }
    ]
  },
  {
    id: 'quizMetroMusic8',
    type: 'single',
    image: 'quizMetroMusic-8.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1'
      },
      {
        id: 2,
        value: '2'
      },
      {
        id: 3,
        value: '3'
      }
    ]
  },
  {
    id: 'quizMetroMusic9',
    type: 'single',
    image: 'quizMetroMusic-9.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Céline DION'
      },
      {
        id: 2,
        value: 'Marc LAVOINE'
      },
      {
        id: 3,
        value: 'Christophe WILLEM'
      }
    ]
  },
  {
    id: 'quizMetroMusic10',
    type: 'single',
    image: 'quizMetroMusic-10.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: 'Bercy (ligne 14)'
      },
      {
        id: 2,
        value: 'Gambetta (ligne 3)'
      },
      {
        id: 3,
        value: 'Jaurès (ligne 5)'
      }
    ]
  }
]

export const quizJEP: Quiz = [
  {
    id: 'quizJep1',
    type: 'single',
    image: 'quizJep-1.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: '1977'
      },
      {
        id: 2,
        value: '1986'
      },
      {
        id: 3,
        value: '2014'
      }
    ]
  },
  {
    id: 'quizJep2',
    type: 'single',
    image: 'quizJep-2.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Plan indicateur lumineux d\'itinéraires'
      },
      {
        id: 2,
        value: 'Programme itinérant de localisation intuitif'
      },
      {
        id: 3,
        value: 'Pilotage Intelligent de Lignes Informatisées'
      }
    ]
  },
  {
    id: 'quizJep3',
    type: 'single',
    image: 'quizJep-3.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1895'
      },
      {
        id: 2,
        value: '1908'
      },
      {
        id: 3,
        value: '1936'
      }
    ]
  },
  {
    id: 'quizJep4',
    type: 'single',
    image: 'quizJep-4.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Ligne 21'
      },
      {
        id: 2,
        value: 'Ligne 38'
      },
      {
        id: 3,
        value: 'Ligne 72'
      }
    ]
  },
  {
    id: 'quizJep5',
    type: 'single',
    image: 'quizJep-5.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '1998'
      },
      {
        id: 2,
        value: '2004'
      },
      {
        id: 3,
        value: '2016'
      }
    ]
  },
  {
    id: 'quizJep6',
    type: 'single',
    image: 'quizJep-6.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: '1997'
      },
      {
        id: 2,
        value: '2003'
      },
      {
        id: 3,
        value: '2017'
      }
    ]
  },
  {
    id: 'quizJep7',
    type: 'single',
    image: 'quizJep-7.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '1949'
      },
      {
        id: 2,
        value: '1961'
      },
      {
        id: 3,
        value: '1974'
      }
    ]
  },
  {
    id: 'quizJep8',
    type: 'single',
    image: 'quizJep-8.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: 'Une nouvelle ligne de métro ouverte à l\'occasion des Jeux Olympiques de 2024'
      },
      {
        id: 2,
        value: 'Une gamme de produits iconiques inspirés du patrimoine de la RATP'
      },
      {
        id: 3,
        value: 'Un recueil de poèmes publié par des voyageurs du réseau RATP'
      }
    ]
  },
  {
    id: 'quizJep9',
    type: 'single',
    image: 'quizJep-9.webp',
    goodOptionId: 1,
    options: [
      {
        id: 1,
        value: 'Ligne 1'
      },
      {
        id: 2,
        value: 'Ligne 3'
      },
      {
        id: 3,
        value: 'Ligne 6'
      }
    ]
  },
  {
    id: 'quizJep10',
    type: 'multiple',
    image: 'quizJep-10.webp',
    goodOptionsIds: [2, 3],
    options: [
      {
        id: 1,
        value: 'C\'était à la mode dans les années 1900'
      },
      {
        id: 2,
        value: 'Pour permettre un meilleur éclairage des stations'
      },
      {
        id: 3,
        value: 'Pour une question d\'hygiène'
      }
    ]
  },
  {
    id: 'quizJep11',
    type: 'single',
    image: 'quizJep-11.webp',
    goodOptionId: 2,
    options: [
      {
        id: 1,
        value: '5'
      },
      {
        id: 2,
        value: '9'
      },
      {
        id: 3,
        value: '13'
      }
    ]
  },
  {
    id: 'quizJep12',
    type: 'single',
    image: 'quizJep-12.webp',
    goodOptionId: 3,
    options: [
      {
        id: 1,
        value: '10 ans'
      },
      {
        id: 2,
        value: '28 ans'
      },
      {
        id: 3,
        value: '41 ans'
      }
    ]
  }
]

export const quizGroupUMOP: Quiz = [
  {
    id: 'quizGroupUmop1',
    type: 'single',
    image: 'quizGroupUMOP-1.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: '10' },
      { id: 2, value: '16' },
      { id: 3, value: '20' },
      { id: 4, value: '25' }
    ]
  },
  {
    id: 'quizGroupUmop2',
    type: 'single',
    image: 'quizGroupUMOP-2.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: '5' },
      { id: 2, value: '7' },
      { id: 3, value: '9' },
      { id: 4, value: '11' }
    ]
  },
  {
    id: 'quizGroupUmop3',
    type: 'single',
    image: 'quizGroupUMOP-3.webp',
    goodOptionId: 4,
    options: [
      { id: 1, value: '30' },
      { id: 2, value: '50' },
      { id: 3, value: '120' },
      { id: 4, value: 'plus de 250' }
    ]
  },
  {
    id: 'quizGroupUmop4',
    type: 'single',
    image: 'quizGroupUMOP-4.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: '2 547' },
      { id: 2, value: '4 586' },
      { id: 3, value: '7 133' },
      { id: 4, value: '8 914' }
    ]
  },
  {
    id: 'quizGroupUmop5',
    type: 'single',
    image: 'quizGroupUMOP-5.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'environ 500 000' },
      { id: 2, value: 'environ 2 millions' },
      { id: 3, value: 'environ 9 millions' }
    ]
  },
  {
    id: 'quizGroupUmop6',
    type: 'single',
    image: 'quizGroupUMOP-6.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: 'RATP Expertises' },
      { id: 2, value: 'RATP Cap Île-de-France' },
      { id: 3, value: 'RATP Cap Arc Sud et Ouest' }
    ]
  },
  {
    id: 'quizGroupUmop7',
    type: 'single',
    image: 'quizGroupUMOP-7.webp',
    goodOptionId: 1,
    options: [
      { id: 1, value: 'la ligne 171' },
      { id: 2, value: 'la ligne 6201' },
      { id: 3, value: 'la ligne 6217' }
    ]
  },
  {
    id: 'quizGroupUmop8',
    type: 'single',
    image: 'quizGroupUMOP-8.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: 'le T2' },
      { id: 2, value: 'le T6' },
      { id: 3, value: 'le T13' }
    ]
  },
  {
    id: 'quizGroupUmop9',
    type: 'single',
    image: 'quizGroupUMOP-9.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: '6' },
      { id: 2, value: '9' },
      { id: 3, value: '11' }
    ]
  },
  {
    id: 'quizGroupUmop10',
    type: 'single',
    image: 'quizGroupUMOP-10.webp',
    goodOptionId: 2,
    options: [
      { id: 1, value: '10' },
      { id: 2, value: '13' },
      { id: 3, value: '17' }
    ]
  },
  {
    id: 'quizGroupUmop11',
    type: 'single',
    image: 'quizGroupUMOP-11.webp',
    goodOptionId: 3,
    options: [
      { id: 1, value: 'Lignes 15 et 16' },
      { id: 2, value: 'Lignes 16 et 17' },
      { id: 3, value: 'Lignes 15 et 18' }
    ]
  },
  {
    id: 'quizGroupUmop12',
    type: 'single',
    image: 'quizGroupUMOP-12.webp',
    goodOptionId: 1,
    options: [
      { id: 1, value: 'un parapluie' },
      { id: 2, value: 'un sac' },
      { id: 3, value: 'un téléphone' }
    ]
  }
]